export const userTokUrlParamName = 'user_token'; // osreplace: export const userTokUrlParamName = 'auth_token'
